import { nanoid } from 'nanoid'
import { ToastData, ToastInstance } from '../types'

const DEFAULT_TOAST_TTL = 5

export const createToastInstance = (data: ToastData): ToastInstance => {
  if ('customJsx' in data) {
    return {
      id: nanoid(),
      createdAt: Date.now(),
      customJsx: data.customJsx
    }
  }
  const {
    title,
    id = nanoid(),
    variant = 'info',
    description,
    dismissable = true,
    action,
    ttl = DEFAULT_TOAST_TTL
  } = data
  return {
    id,
    title,
    variant,
    description,
    dismissable,
    action,
    createdAt: Date.now(),
    ttl
  }
}
